import { useState, useRef, useEffect } from "react";
import Header from "../../commonComponents/header/Header";
import arrowImg from "../../../assets/images/arrow-white-icon.svg";
import allSetImg from "../../../assets/images/nh_consumer_all_set.svg";
import { useNavigate, useLocation } from "react-router-dom";
import LoadingDialog from "../../commonComponents/loader/LoadingDialog";
import CommonSnackbar from "../../commonComponents/snackbar/CommonSnackbar";
import { apiService } from "../../../services/apiService";
import {
  updateSession,
  listenSession,
} from "../../../services/firestoreService";

const AllSet = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const interviewId = sessionStorage.getItem("interviewId");
  const companyId = sessionStorage.getItem("companyId");

  const documentId = `${companyId}_${interviewId}`;
  const processingRef = useRef(false);
  const [loading, setLoading] = useState(false);
  const [snackbar, setSnackbar] = useState(null);
  const [overlayVisible, setOverlayVisible] = useState(false);
  const [wsStatus, setWsStatus] = useState(null); // optional debugging
  const unsubscribeRef = useRef(null);

  // Refs
  const audioRef = useRef(null);
  const repeatIntervalRef = useRef(null);

  const apiAbortControllerRef = useRef(null);

  const playEndAssessmentAudio = () => {
    return new Promise((resolve, reject) => {
      const audio = new Audio("/sounds/end-assessment1.mp3");
      audio.preload = "auto";

      audio.onended = () => resolve();
      audio.onerror = (e) => resolve(); // even if audio fails, continue

      audio.play().catch(() => resolve());
    });
  };

  // function to start the overlay flow
  const startProctoringFlow = async () => {
    if (processingRef.current) return;
    processingRef.current = true;
    try {
      const interviewId = sessionStorage.getItem("interviewId");
      const companyId = sessionStorage.getItem("companyId");

      const documentId = `${companyId}_${interviewId}`;

      setOverlayVisible(true);

      // 🎵 audio (keep your existing logic)
      if (!audioRef.current) {
        audioRef.current = new Audio("/sounds/moonshot360.mp3");
        audioRef.current.preload = "auto";
      }

      try {
        await audioRef.current.play();
      } catch {}

      repeatIntervalRef.current = setInterval(() => {
        if (audioRef.current) {
          audioRef.current.currentTime = 0;
          audioRef.current.play().catch(() => {});
        }
      }, 15000);

      // await apiService.setMoonshotProctoringStatus({
      //   interviewId,
      //   status: 1,
      // });

      //  STEP 1: Update Firestore → status = 1
      await updateSession(documentId, {
        status: 1,
      });

      //  STEP 2: Listen for status = 2
      unsubscribeRef.current = listenSession(documentId, async (data) => {
        if (!data) return;

        console.log("Firestore update:", data);

        if (data.status === 2) {
          cleanupFirestoreListener();
          stopAudioAndWs();
          setOverlayVisible(false);

          // Check screenshot proctoring flag
          const screenshotFlag = sessionStorage.getItem(
            "mobileProctoringScreenshot",
          );

          if (screenshotFlag === "false") {
            setTimeout(async () => {
              try {
                await updateSession(documentId, { status: 777 });
              } catch (err) {
                console.error("Failed to update status to 777", err);
              }
            }, 5000);
          }

          setSnackbar({
            message: "Video captured successfully!",
            type: "success",
          });

          navigate("/assessment", {
            state: { redirectFrom: "allSet" },
          });
        }
      });
    } catch (err) {
      console.error(err);
      setOverlayVisible(false);
    }
  };
  const cleanupFirestoreListener = () => {
    if (unsubscribeRef.current) {
      try {
        unsubscribeRef.current();
      } catch (e) {}
      unsubscribeRef.current = null;
    }
  };

  // connect and listen to websocket messages
  const connectWebSocket = (id) => {
    try {
      const interviewId = sessionStorage.getItem("interviewId");
      const companyId = sessionStorage.getItem("companyId");
    } catch (err) {
      console.error("connectWebSocket failed", err);
      setSnackbar({
        message: "Unable to open websocket.",
        type: "failure",
      });
    }
  };

  // stop audio and clear interval & web socket
  const stopAudioAndWs = () => {
    cleanupFirestoreListener();

    if (repeatIntervalRef.current) {
      clearInterval(repeatIntervalRef.current);
      repeatIntervalRef.current = null;
    }

    if (audioRef.current) {
      audioRef.current.pause();
      audioRef.current.currentTime = 0;
    }
  };

  // cleanup on unmount
  useEffect(() => {
    return () => {
      cleanupFirestoreListener();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // handle Proceed button (keeps same naming)
  const handleProceed = async () => {
    if (processingRef.current) return;
    const moonshotFlag = sessionStorage.getItem("mobileProctoringVideo");

    // If value is "false" → skip proctoring
    if (moonshotFlag === "false") {
      navigate("/assessment", {
        state: { redirectFrom: "allSet" },
      });
      return;
    }

    // If true or missing -> show overlay as usual
    startProctoringFlow();
  };

  return (
    <div className="flex flex-col min-h-screen bg-white overflow-x-hidden px-4 pt-4">
      {/* Header */}
      <Header />

      {loading && (
        <LoadingDialog
          title="Verifying Sync-Code"
          bottomMsg="This will be just a moment..."
        />
      )}

      {snackbar && (
        <CommonSnackbar
          message={snackbar.message}
          type={snackbar.type}
          onClose={() => setSnackbar(null)}
        />
      )}

      {/* Main Content Area */}
      <div className="flex-1 flex flex-col md:flex-row items-center justify-center  pt-5  max-w-9xl ">
        {/* Left Section */}
        <div className="w-full md:w-1/2 flex justify-center items-center pl-[34px] pr-[50px]">
          <img
            src={allSetImg}
            alt="allSetImg"
            className="object-contain w-[100%] h-[100%] rounded-3xl"
          />
        </div>
        {/* Divider */}
        <div className="hidden md:block self-stretch w-[1px]  bg-dividerColor mx-1 my-[5%]" />

        {/* Right Section */}
        <div className="w-full md:w-1/2 flex flex-col justify-between px-5">
          {/* Text Content */}
          <div>
            <h2 className="font-semibold text-fontColor mb-2 app-title outer-font-color">
              All Set!
            </h2>
            <p className="text-fontColor mb-8 leading-relaxed text-base app-body outer-font-color">
              Congratulations! All required steps to begin your assessment are
              now complete.
            </p>
            <p className="text-fontColor  leading-relaxed text-base app-body outer-font-color">
              Please click on <span style={{ fontWeight: 500 }}>"Proceed"</span>{" "}
              when you are ready to start your assessment.
            </p>
          </div>
        </div>
      </div>

      {/* Buttons container at the bottom */}
      <div className="mt-auto w-full flex justify-end pb-4">
        <button
          className="app-button flex bg-btnBgColor items-center justify-center px-6 py-1.5  text-white transition disabled:opacity-30 mr-[36px]"
          onClick={handleProceed}
        >
          Proceed
          <img src={arrowImg} alt="arrowImg" className="ml-2" />
        </button>
      </div>

      {/* Footer */}
      <div className="w-full py-4 text-[10px] text-gray-600 text-center px-4">
        ©{" "}
        {new Date().getFullYear() > 2026
          ? `2026-${new Date().getFullYear()}`
          : "2026"}
        , Needles and Haystacks Technology Pvt Ltd.
      </div>

      {/* Overlay */}
      {overlayVisible && (
        <div
          aria-modal="true"
          role="dialog"
          className="fixed inset-0 z-50 flex items-center justify-center"
        >
          {/* backdrop */}
          <div
            className="absolute inset-0"
            style={{
              backgroundColor: "rgba(0,0,0,0.9)", // 90% opacity black
            }}
          />

          {/* content */}
          <div className="relative z-60 max-w-3xl w-full mx-4">
            <div className="bg-transparent rounded-lg flex flex-col items-center justify-center p-6">
              <h1 className="app-title text-white text-center text-3xl md:text-5xl font-bold leading-tight">
                Please take a 360° video from the NeedleEye app
              </h1>
              <br />
              <br />
              <h1 className="text-white app-body text-center text-3xl md:text-5xl  leading-tight">
                Make sure to record the 360-degree video from the NeedleEye app
                within 3 minutes. <br /> If it is not completed, your assessment
                will be ended.
              </h1>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default AllSet;
